var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_vm._m(0),_c('Introduce'),_c('BossMessage'),_c('Cultural'),_c('Business'),_c('Contact')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-img"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("@/assets/images/k2hqdmpfendk2hqdmpfend.jpg"),"alt":"YwgA84rAI"}})])
}]

export { render, staticRenderFns }